"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "grosio": {
    "ffc8527f": [{
      "hkey": "f10650b5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ravoledo": [{
      "hkey": "f10650b5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "grosio"
    }],
    "0440b70d": [{
      "hkey": "f10650b5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "vernuga": [{
      "hkey": "f10650b5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "grosio"
    }]
  }
};
exports["default"] = _default;